module.exports = __webpack_public_path__ + "static/img/ic_duichong.6302e659.png";